import { createRoomDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useRoomDetailsQuery = createRoomDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
